import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import template from './index.jade';
import css from './index.styl?inline';

type MessageBannerState = {
  visible: boolean;
};

export class ReportMessageBanner extends Component<MessageBannerState> {
  static get attrsSchema() {
    return {
      closeable: `boolean`,
      message: `string`,
      size: `string`,
      title: `string`,
      type: `string`,
      visible: `boolean`,
    };
  }

  get config() {
    return {
      template,
      css,
      useShadowDom: true,
      defaultState: {
        visible: false,
      },
      helpers: {
        hideBanner: () => {
          this.dispatchEvent(new CustomEvent(`close`));
          this.update({visible: false});
        },
      },
    };
  }

  attributeChangedCallback(attr, oldValue, newValue) {
    super.attributeChangedCallback(attr, oldValue, newValue);
    if (attr === `visible`) {
      // visible attr change overrides internal state
      this.update({visible: this.attr(attr)});
    }
  }
}

export const ReportMessageBannerEl = defineAndMakeJsxFactory(`mp-report-message-banner`, ReportMessageBanner);
